import { render, staticRenderFns } from "./WeekInDetail.vue?vue&type=template&id=a510fd70&scoped=true";
import script from "./WeekInDetail.vue?vue&type=script&lang=js";
export * from "./WeekInDetail.vue?vue&type=script&lang=js";
import style0 from "./WeekInDetail.vue?vue&type=style&index=0&id=a510fd70&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "a510fd70", null);
export default component.exports;